@if (!hasFloor()) {
  <sd-system-message type="warning">
    в
    <a class="link-underlined" (click)="openAddressModal()">адресе доставки</a>
    не указан этаж
  </sd-system-message>
} @else {
  <button class="lifting-options-button color-black" (click)="openAddressModal()">
    <span class="text-c1-l-300">{{ floorLiftInfo() }}</span>
    <sd-icon [type]="iconTypes.ARROW_RIGHT" class="icon-size-xxs" />
  </button>
  <div>
    <form class="lifting-options-form" [formGroup]="form">
      <sd-toggle formControlName="enabled">
        <span class="text-b3-s-300">расстояние от машины до входа в здание больше 30м?</span>
      </sd-toggle>

      @if (form.controls.enabled.value === true) {
        <sd-input label="укажите примерное количество метров" comment="до 30м бесплатно">
          <input
            #inputRef
            formControlName="carryingDistance"
            type="text"
            mask="F000"
            [validation]="false"
            [patterns]="customPattern"
            (keydown.enter)="inputRef.blur()"
          />
        </sd-input>
      }
    </form>
  </div>
}
